export enum OrderType {
  Payin = 'payin',
  Payout = 'payout',
}
